import { useUserWalletList } from '../api/useUserWalletList'

export const useUserPayoutWallet = () => {
    const { data: wallets, isFetching, isFetched } = useUserWalletList()
    const hasWalletConnected = wallets?.length > 0
    const wallet = wallets?.find((w) => w.is_payout)
    return { wallet, hasWalletConnected, isFetching, isFetched }
}
